import React from "react";
import ReactDOM from 'react-dom/client';

import {
  Routes,
  Route,
} from "react-router";

import { UserManager } from 'oidc-client-ts';

import {
  createRoutes,
  setupAuthOidcConfig,
  AuthProvider,
  AuthTestApp,
  authBootstrap,
} from "clnt-common";

import { loadEnvVar } from '#src';
import routeList from './routeList';
import App from './App';

const isTest = false;   //true;
const isTestSilent = true;   // use the silent mode redirect w/ prompt=none

const printBanner = (getEnvVar) => {
  let appCode = getEnvVar.APP_CODE;   //'RECL' | 'CRUD' | 'BITI' | 'NULC' | TMPL'  
  console.info('=====================================================================================');
  console.info('==                                                                                 ==');
  console.info('        *** !!! App: ' + appCode + ' - Mode: ' + getEnvVar.RUN_ENV + ' - Node Env: ' + getEnvVar.NODE_ENV + ' !!! ***            ');
  console.info('==                                                                                 ==');
  console.info('=====================================================================================');
}

const onRecoverableError = (error, errInfo) => {
  let context = {};
 
  if (errInfo?.componentStack) {
     // Generating this synthetic error allows monitoring services to apply sourcemaps
     // to unminify the stacktrace and make it readable.
     const errorBoundaryError = new Error(error.message);
     errorBoundaryError.name = `React ErrorBoundary ${errorBoundaryError.name}`;
     errorBoundaryError.stack = errInfo.componentStack;
 
     // REF: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
     error.cause = errorBoundaryError;
 
     // You can also just add the plain text as added event context.
     context.componentStack = errInfo.componentStack;
  }
 
  // Replace with your error monitoring service.
  // MyObservabilityPlatform.captureException(error, { context })
  console.error('entry-client:onRecoverableError() - error: ' + JSON.stringify(error)); 
}

const runTest = async (root, userManager) => {
  console.debug('entry-client:runTest() begin');
  ReactDOM.createRoot(root).render(
    <AuthProvider userManager={userManager}>
      <AuthTestApp style={{ padding: 140, backgroundColor: 'red' }} isTestSilent={isTestSilent} />
    </AuthProvider>
  );
}

const runApp = async (root, routeList, getEnvVar, user, userManager) => {
  console.debug('entry-client:runApp() begin');

  //
  // Setup client side routing
  // returns: { routes[{path:, element:,}], head, context }
  // Only routes is relevant on client side.
  // head/context are used on server side.
  //

  const { routes } = await createRoutes(routeList, window.location.pathname);

  //
  // context comes from /src/function.js and it's placed in <script> tag by server side renderer
  // Which sets up the window.__context__ 
  // For SPA, the server side is not involved. NGNX serves the html and js which were build by vite
  
  // context = { type: , srvrData: , fetchData: , metaData: , allSrvrData: }    
  // srvrData = { slug: 'aaa', data: psqlData};
  // fetchData = { slug: 'aaa', data: psqlData};
  // metaData = { page: page, layout: '', advert: {}, head: [], meta: { type: 'tsxpage', } };
  // allSrvrData = { 'route1': route1Data, 'route2': route2Data, }
  
  let context = { };
  if (typeof window !== 'undefined' && typeof window.__context__ !== 'undefined') {
    context = window.__context__;
  }

  const currentRoute = window.location.pathname;    

  // ssg: processed by node server; sets type to 'ssg' and wipes out data
  // ssr: processed by node server; sets type to 'ssr' TODO
  // spa: NOT processed by node server; type is not set;
  //const mount = (context, children, userManager) => {

  const type = context && context.type || 'spa';

  if (type === 'ssr' || type === 'ssg') {
    // SSR case
    ReactDOM.hydrateRoot(root,
      <AuthProvider userManager={userManager}>
	<App appContext={context}
	  routes={routes}
	  route={currentRoute}
	  getEnvVar={getEnvVar}
	  user={user}
	/>
      </AuthProvider>,
      { onRecoverableError }
    );
  }
  else {
    // SPA case
    ReactDOM.createRoot(root).render(
      <AuthProvider userManager={userManager}>
	<App appContext={context}
	  routes={routes}
	  route={currentRoute}
	  getEnvVar={getEnvVar}
	  user={user}
	/>
      </AuthProvider>
    );
  }
}

const bootstrap = async () => {
  const getEnvVar = await loadEnvVar('/src/data/');
  console.debug('entry-client:bootstrap() - downloaded getEnvVar');

  printBanner(getEnvVar);

  const oidcConfig = setupAuthOidcConfig(getEnvVar);
  const root = document.getElementById('app');

  async function kbootstrap() {
    const userManager = new UserManager(oidcConfig);
    let user = null;
    try {
      await authBootstrap(userManager, isTestSilent);
      console.debug('entry-client:kbootstrap() - issue userManager.getUser()');
      user = await userManager.getUser();
    }
    catch(e) {
      console.warn('entry-client:kbootstrap() exception calling authBootstrap() error', e.message);
    }

    if (isTest) {
      runTest(root, userManager);
    }
    else {
      runApp(root, routeList, getEnvVar, user, userManager);
    }
  }

  kbootstrap();
}  
bootstrap()
